import { Mail, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ClosingContactStrip() {
  return <section data-section-id="261520" id="closing-contact-strip" className="bg-background text-foreground py-12 md:py-16 border-t border-muted">
      <div className="page-container flex flex-col md:flex-row items-center justify-between gap-8 text-center md:text-left max-w-[800px] mx-auto">
        <div className="flex-1">
          <span className="font-default text-xs font-bold uppercase tracking-widest text-secondary block mb-2">
            QUESTIONS ABOUT THESE TERMS?
          </span>
          <h2 className="font-default text-xl md:text-2xl lg:text-3xl font-bold tracking-tight text-foreground">
            We are happy to walk you through anything before you get started.
          </h2>
          <p className="mt-2 text-muted-foreground text-sm max-w-xl mx-auto md:mx-0">
            Reach out anytime — we respond within 24 hours.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center gap-4 shrink-0">
          <div className="flex flex-col items-center md:items-start gap-2">
            <Link to="mailto:hello@blinklabmedia.com" className="flex items-center text-foreground font-default text-sm hover:text-secondary transition-colors">
              <Mail className="mr-2 size-4 text-secondary" />
              hello@blinklabmedia.com
            </Link>
            <Link to="tel:803-470-4042" className="flex items-center text-foreground font-default text-sm hover:text-secondary transition-colors">
              <Phone className="mr-2 size-4 text-secondary" />
              803-470-4042
            </Link>
          </div>

          <Button asChild variant="outline" size="lg" className="h-12 px-6 text-sm font-bold border-2 border-secondary text-secondary hover:bg-secondary hover:text-secondary-foreground bg-transparent shadow-md hover:scale-105 transition-transform duration-300 rounded-md">
            <Link to="/ContactPage">
              Contact Us
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}